import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InputImage } from "../../../../../Layout/Forms/Form";
import VipTablesRequests from '../VipTablesRequests';

const FormFloorImage = ({ show, handleModalShow, handleModalhide, id }) => {
    const [isLoading, setIsLoading] = useState(false);
    let params = useParams();
    const navigate = useNavigate();




    const handleAcceptTerms = async () => {
        setIsLoading(true);
        let info = await VipTablesRequests.acceptTerms({ id_venues: params.id });
        if (info && info.status) {
            handleModalhide()

        }
        setIsLoading(false);
    }

    const handleCancel = () => {
        navigate(`/my/nightspots`);
    }

    return (
        <>
            <Modal show={show} onHide={handleCancel} dialogClassName="width-95vw">
                <Modal.Header closeButton>
                    <Modal.Title>Termos & Condições</Modal.Title>
                </Modal.Header>

                <Modal.Body >

                    <div className="row" style={{ height: '75vh', overflowY: 'scroll' }}>
                        <div className="col-12 px-5">
                            <div>
                                <p><strong><span style={{ fontSize: '10pt' }}>Termos e Condições</span></strong></p>
                                <p style={{ textAlign: 'justify' }}><span style={{ fontSize: '10pt' }}>Os presentes Termos e Condições destinam-se a regular as condições gerais de uso do módulo de reserva de mesas, módulo bilhética, e módulo guest list e informação legal da Forever Friday, Lda (doravante Nightspot), pessoa coletiva com NIF 517 654 377, com sede em Rua Terraços de Vale de Lobos, N.º 49, 1.º Esq., Barreira, 2410-491 Leiria, se iram reger.</span></p>
                                <p><br /></p>
                                <ol>
                                    <li><strong>
                                        <ul style={{ listStyle: 'none' }}>
                                            <li style={{ fontSize: '10pt' }}>
                                                <p><span style={{ fontSize: '10pt' }}>Responsabilidade da Emissão da Fatura:</span></p>
                                            </li>
                                        </ul>
                                    </strong></li>
                                </ol>
                                <p><span style={{ fontSize: '10pt' }}>Os responsáveis pelos estabelecimentos são exclusivamente responsáveis pela emissão da fatura ao cliente referente ao valor cobrado pela reserva da mesa.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>A emissão da fatura deve ser realizada dentro dos prazos legais estabelecidos pelas autoridades competentes. O NightSpot não se responsabiliza por atrasos ou problemas decorrentes da emissão da fatura.</span></p>
                                <p><br /></p>
                                <p><br /></p>
                                <ol start={2}>
                                    <li><strong>
                                        <ul style={{ listStyle: 'none' }}>
                                            <li style={{ fontSize: '10pt' }}>
                                                <p><span style={{ fontSize: '10pt' }}>Comissão do NightSpot:</span></p>
                                            </li>
                                        </ul>
                                    </strong></li>
                                </ol>
                                <p><span style={{ fontSize: '10pt' }}>A NightSpot.pt cobrará uma comissão de 5% sobre o valor de cada transação realizada através da plataforma de reserva de mesas VIP.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Após o pagamento, a comissão cobrada não será reembolsada em nenhuma circunstância.</span></p>
                                <p><br /></p>
                                <p><br /></p>
                                <ol start={3}>
                                    <li><strong>
                                        <ul style={{ listStyle: 'none' }}>
                                            <li style={{ fontSize: '10pt' }}>
                                                <p><span style={{ fontSize: '10pt' }}>Reembolsos:</span></p>
                                            </li>
                                        </ul>
                                    </strong></li>
                                </ol>
                                <p><span style={{ fontSize: '10pt' }}>Todos os pedidos de reembolso devem ser enviados por e-mail para: info@nightspot.pt.</span></p>
                                <p><br /></p>
                                <ol start={4}>
                                    <li><strong>
                                        <ul style={{ listStyle: 'none' }}>
                                            <li style={{ fontSize: '10pt' }}>
                                                <p><span style={{ fontSize: '10pt' }}>Solicitação de Levantamento de Fundos:</span></p>
                                            </li>
                                        </ul>
                                    </strong></li>
                                </ol>
                                <p><span style={{ fontSize: '10pt' }}>Os utilizadores podem solicitar o levantamento de fundos através da seção "Gestão Financeira" no separador "Pagamentos" da plataforma.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Nesta seção, os utilizadores podem visualizar o saldo disponível e solicitar o levantamento dos fundos.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>O processamento do levantamento podem levar até 48 horas úteis para serem concluídos.</span></p>
                                {/* <p><span style={{ fontSize: '10pt' }}>Os saldos só podem ser levantados após a conclusão do evento.</span></p> */}
                                <p><br /></p>
                                <ol start={5}>
                                    <li><strong>
                                        <ul style={{ listStyle: 'none' }}>
                                            <li style={{ fontSize: '10pt' }}>
                                                <p><span style={{ fontSize: '10pt' }}>Alterações nos Termos e Condições:</span></p>
                                            </li>
                                        </ul>
                                    </strong></li>
                                </ol>
                                <p><span style={{ fontSize: '10pt' }}>O NightSpot reserva-se ao direito de fazer alterações nos presentes Termos e Condições a qualquer momento, mediante aviso prévio aos usuários.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Ao continuar a utilizar os serviços após a entrada em vigor das alterações, os usuários concordam e aceitam os novos Termos e Condições.</span></p>
                                <p><br /></p>
                                <p><strong><span style={{ fontSize: '10pt' }}>Disposições Gerais</span></strong><span style={{ fontSize: '10pt' }}>:</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Estes Termos e Condições representam o acordo integral entre os usuários e o NightSpot no que diz respeito aos serviços de reserva de mesas VIP e pagamento online.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Em caso de qualquer conflito entre estes Termos e Condições e quaisquer outros acordos ou políticas relacionadas, estes prevalecerão.</span></p>
                                <p><span style={{ fontSize: '10pt' }}>Ao utilizar os serviços do NightSpot, você concorda em cumprir integralmente estes Termos e Condições. Se tiver alguma dúvida ou preocupação, entre em contato conosco através do e-mail fornecido acima. Obrigado por escolher o NightSpot</span></p>
                            </div>


                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleCancel}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleAcceptTerms}>
                        Aceitar
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer /> */}
        </>
    )
}

export default FormFloorImage;